import { FormSection } from '@ksyos/design-system';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import type { IServiceOrganizationSettingFormSectionProps } from '../ServiceOrganizationSetting';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { translateKey } from '../../../../../translate';

export function SendingHolter(props: IServiceOrganizationSettingFormSectionProps) {
    if (props.service.code !== ServiceCode.TCOH) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.sendingHolter')}>
            <FormParagraphFormGroup label={translateKey('serviceOrganizationSetting.isSendingDeviceToPatientsAddress')}>
                {props.isSendingDeviceToPatientsAddress ? translateKey('common.yes') : translateKey('common.no')}
            </FormParagraphFormGroup>
        </FormSection>
    );
}
